import { isNil } from 'lodash'
import { TProductMap } from '../model/product-status.store'

export function getOutOfStock(productMap: TProductMap, sku: string) {
  return isNil(productMap[sku]) ? true : !productMap[sku].inStock
}
